<template>
  <div>
    <!-- 车组树状图开始 -->
    <div class="tree">
      <div class="tree__header">
        <div class="tree__title">
          设备列表
        </div>
        <el-button
          type="text"
          size="small"
          @click="clearAllData()"
          v-if="vehGroup.gids.size > 0"
        >取消选择</el-button>
      </div>

      <div class="tree__content">
        <el-tree
          ref="tree"
          :data="treeData"
          :props="defaultProps"
          node-key="organizationId"
          :expand-on-click-node="false"
          @node-click="hanldeNodeClick"
          check-strictly
          highlight-current
          :default-expanded-keys="openKeys"
        >
          <span
            class="tree__node"
            :class="{'tree__node_on': vehGroup.gids.has(data.organizationId)}"
            slot-scope="{ node, data }"
          >
            <i
              class="tree__icon iconfont icon-shebei"
              :class="{tree__node_on:vehGroup.gids.has(data.organizationId)}"
            />
            <span>{{ data.organizationName }}</span>
            <span class="tree__total">({{ data.sum }})</span>
          </span>
        </el-tree>
      </div>
    </div>
    <!-- 车组树状图结束 -->

    <!-- 搜索框开始 -->
    <QueryVehOrGroup
      v-model="searchValue"
      style="margin: 5px"
    />
    <!-- 搜索框结束 -->

    <!-- 车辆选择开始 -->
    <div
      class="VehSelect"
      ref="VehSelect"
    >
      <div class="VehSelect__nav">
        <div
          class="VehSelect__tab-item"
          v-for="(item,index) in tabItems"
          :key="index"
          :class="{'VehSelect__tab-item_on': type === item.type}"
          @click="selectType(item)"
        >
          <div>{{item.label}}</div>
          <div>({{vehGroup.gids.size > 0?item.total:0}})</div>
        </div>
      </div>
      <!-- <div class="VehSelect__cancel">
        <el-button
          type="text"
          size="small"
          @click="allSelect(!isAllSelect)"
        >{{isAllSelect ? '取消全选' : '全选'}}</el-button>
      </div> -->
      <div
        :class="{
          VehSelect__box:!loading,
          VehSelect__box2:loading
        }"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 1)"
      >
        <div
          class="VehSelect__loading"
          v-show="!dataList.length"
        >
          <Empty />
        </div>
        <div
          class="VehSelect__tab-pane"
          v-for="(item,index) in dataList"
          :key="index"
        >
          <div class="VehSelect__tab-pane-content">
            <div
              class="VehItem"
              :class="{
              //VehItem_on: vehIndices.value.has(item.vehicleId),
              VehItem_on: selectIds.has(item.vehicleId),
              VehItem_online: item.type === 0,
              VehItem_valid: item.type !== 2,
              VehItem_disabled: item.type === 3,
              VehItem_active: selectVeh && selectVeh.vehicleId === item.vehicleId
              //VehItem_active: vehInfo && vehInfo.vehicleId === item.vehicleId
            }"
              @click="handleOnVehItemClick(item, true);"
            >
              <i class="VehItem__veh-icon iconfont icon-truck" />
              <div class="VehItem__plate">{{item.bmsNo}}</div>
              <div
                class="VehItem__status"
                :title="computedVehState(item)"
              >[{{ computedVehState(item) }}]</div>
              <el-button
                v-if="selectIds.has(item.vehicleId)"
                type="text"
                size="small"
                style="padding: 0 20px;margin-left: 5px"
                @click.stop="handleOnVehItemClick(item, false)"
              >取消</el-button>
            </div>
            <el-popover
              placement="right"
              trigger="click"
              :visible-arrow="false"
            >
              <div style="padding:0px">
                <div
                  v-if="[1,2].includes(USER.accountType)"
                  class="optionBtn"
                  @click.stop="optionsFn(11,item)">
                  <div class="options">远程升级</div>
                </div>
                <div
                  class="optionBtn"
                  @click.stop="optionsFn(12,item)">
                  <div class="options">读写寄存器</div>
                </div>
                <template v-for="(item, index) in deviceOptions" >
                    <div class="optionBtn" :key="index" v-if="index > 2?isCKBMS:index == 2 && isSUNWODA?false:true">
                      <div class="options" v-if="index<3" @click="optionsFn(item.value)" >{{item.title}}</div>
                      <div class="options" v-else  >
                          <el-popover
                          placement="right-start"
                          :title="'下发'+item.title"
                          width="200"
                          :offset="200"
                          trigger="hover"
                          >
                          <div style="text-align: right; margin: 0">
                              <el-button type="primary" size="mini" @click="specification('<'+ item.value +'>')">下发</el-button>
                          </div>
                          <span slot="reference">{{item.title}}</span>
                          </el-popover>
                      </div>
                    </div>
                </template>
                <template v-if="isSUNWODA">
                  <div class="optionBtn" @click="optionsFn(4,'电池输出开关')">
                    <div class="options block_div">电池输出开关</div>
                  </div>
                  <div class="optionBtn" @click="optionsFn(5,'电池充电开关')">
                    <div class="options block_div">电池充电开关</div>
                  </div>
                  <div class="optionBtn" @click="optionsFn(6,'电池休眠开关')">
                    <div class="options block_div">电池休眠开关</div>
                  </div>
                  <div class="optionBtn" @click="optionsFn(7,'电池工作模式')">
                    <div class="options block_div">电池工作模式</div>
                  </div>
                  <div class="optionBtn" @click="optionsFn(8,'电池充电模式')">
                    <div class="options block_div">电池充电模式</div>
                  </div>
                  <div class="optionBtn" @click="optionsFn(9,'查询位置信息/电池数据')">
                    <div class="options block_div">查询位置信息/电池数据</div>
                  </div>
                  <div class="optionBtn" @click="optionsFn(10,'设置定位器上报频率')">
                    <div class="options block_div">设置定位器上报频率</div>
                  </div>
                </template>
              </div>
              <el-button
                type="text"
                size="mini"
                style="position:absolute; right:5px;top:0;overflow:hidden"
                slot="reference"
                @click="setOption(item)"
              ><i class="iconfont icon-setting" /></el-button>
            </el-popover>
          </div>
        </div>
      </div>
      <!-- 分页开始 -->
      <el-pagination
        :current-page.sync="currentPage"
        @current-change="currentChange"
        :page-size.sync="pageSize"
        layout="prev, pager, next"
        :total="total"
        size="small"
        :pager-count="5"
        style="background: #fff;text-align: center;"
      />
      <!-- 分页结束 -->
    </div>
    <!-- 车辆选择结束 -->
    <CommandDown
      :visible.sync="CommandDownVisible"
      :params.sync="selectOption"
      :isData.sync="isData"
    />
    <ChargeTaggle
      :visible.sync="ChargeTaggleVisible"
      :params.sync="selectOption"
    />
    <DeviceDetailDialog
      :visible.sync="DeviceDetailVisible"
      :params.sync="vehicleDetail"
    />
    <!-- 欣旺达 start -->
    <Inst
      :visible.sync="InstVisible"
      :params.sync="selectOption"
      :type="instType"
      :title="instTitle"
    />
    <!-- 欣旺达 end -->
    <!-- 远程升级 -->
    <RemoteUpgrade
      :visible.sync="remoteUpgradeVisible"
      :params.sync="remoteUpgradeData"
    />
    <!-- 寄存器指令 -->
    <ReadWriteRegister
      :visible.sync="registerVisible"
      :params.sync="remoteUpgradeData"
      :refresh="refresh"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
// import { toTreeData } from "@/assets/js/base";
import QueryVehOrGroup from "@/components/QueryVehOrGroup/index.vue";
import Empty from "@/components/Empty/index.vue";
import CommandDown from "@/components/DeviceCommandDownDialog/index.vue";
import DeviceDetailDialog from "@/components/DevicesDetailDialog/index.vue";
import Inst from "@/components/SuWuDa/inst.vue";
import ChargeTaggle from "../../components/DeviceCommandDownDialog/chargeTaggle.vue";
import RemoteUpgrade from './RemoteUpgrade.vue';
import ReadWriteRegister from './ReadWriteRegister.vue';
import { mapMutations } from 'vuex';

export default {
  components: {
    ChargeTaggle,
    QueryVehOrGroup,
    Empty,
    CommandDown,
    DeviceDetailDialog,
    Inst,
    RemoteUpgrade,
    ReadWriteRegister
  },

  props: {
    //当前设备地图信息
    vehInfo: {
      type: [Object, null]
    },
    selectMonitorInfo: {
      type: [Object, null]
    },
    selectElectricData: {
      type: Array
    },
    //当前组织
    vehGroup: {
      type: Object,
      required: true
    },
    //已选设备信息
    vehIndices: {
      type: Object,
      required: true
    },
    monitorInfo: {
      type: Object
    },
    electricData: {
      type: Object
    },
    cyclePagger: {
      type: Number,
      required: true
    },
    type: {
      type: Number, //查询类型 0:在线 1：离线 2：休眠 3：全部（从未上线） 4：过期
      required: true
    },
    refresh:{
      type:Object,
      default: null
    }
  },

  data() {
    return {
      registerVisible:false,
      remoteUpgradeVisible:false,
      remoteUpgradeData:null,
      instTitle:'',
      instType:4,
      InstVisible:false,
      isSUNWODA:false,
      visible:false,
      isCKBMS:false,
      defaultProps: {
        children: "children",
        label: "organizationName"
      },
      deviceOptions: [
        { title: "设备详情", value: 1 },
        //{ title: "控制下发", value: 2 },
        //{ title: "充放电开关", value: 3 },
        { title: "规格数据", value: 'CKBMS:0' },
        { title: "详细数据", value: 'CKBMS:1' }
      ],
      DeviceDetailVisible: false,
      CommandDownVisible: false,
      ChargeTaggleVisible: false,
      selectOption: null,
      selectIds: new Set(), //已选中所有设备id 用于选中速度优化
      selectVeh: null, //当前选中设备 用于选中速度优化
      selectPagger: 1,
      flag: false,
      openKeys: [],
      loading: false,
      organizationId: null,
      pageSize: 100,
      total: 0,
      currentPage: 1,
      gids: [],
      dataList: [], //已选设备信息
      num_data:1,
      tabItems: [
        {
          label: "全部",
          value: "all",
          data: [],
          currentPage: 1,
          type: 3,
          total: 0
        },
        {
          label: "在线",
          value: "online",
          data: [],
          currentPage: 1,
          type: 0,
          total: 0
        },
        {
          label: "离线",
          value: "offline",
          data: [],
          currentPage: 1,
          type: 1,
          total: 0
        },
        // {
        //   label: "休眠",
        //   value: "sleep",
        //   data: [],
        //   currentPage: 1,
        //   type: 2,
        //   total: 0
        // }
      ],
      activeTab: "all",
      // isAllSelect: false, //是否全选按钮
      searchValue: null, //搜索值
      vehicleDetail: [
        { title: "激活时间", value: "暂无数据" },
        { title: "电池编号", value: "暂无数据" },
        { title: "电池类型", value: "暂无数据" },
        { title: "创建时间", value: "暂无数据" },
        { title: "安装时间", value: "暂无数据" },
        // { title: "组织ID", value: "暂无数据" },
        { title: "组织名称", value: "暂无数据" },
        // { title: "IP地址", value: "暂无数据" },
        // { title: "续费多少个月", value: "暂无数据" },
        { title: "服务密码", value: "暂无数据" },
        { title: "SIM号", value: "暂无数据" },
        { title: "设备号", value: "暂无数据" },
        { title: "设备类型", value: "暂无数据" },
        // { title: "更新时间", value: "暂无数据" },
        // { title: "终端ID", value: "暂无数据" },
        { title: "备注", value: "暂无数据" },
        // { title: "地址", value: "暂无数据" },
      ],
      isData:'',
      specificationData: {
        commandMsg: "",
        commandType: "DISPATCH",
        vehicleId: ""
      },
    };
  },

  computed: {
    ...mapState(["GROUPLIST","addressArr","USER"]),
    treeData() {
      return this.treeFormat(this.GROUPLIST);
    }
  },
  watch: {
    vehGroup: {
      async handler(nowVal) {
        this.dataList = [...nowVal.data.filter(item=>item.type ==0),...nowVal.data.filter(item=>item.type == 2),...nowVal.data.filter(item=>item.type != 0 && item.type != 2)];
        // this.vehInfo && this.getPositionData(this.vehInfo);
        //当轮询时，刷新地图弹窗信息
        this.$emit(
          "update:vehInfo",
          Object.freeze(await this.getPositionData(this.vehInfo))
        );
        this.$emit("update:selectMonitorInfo", await this.getMonitorInfo(this.vehInfo));
        // const [all, online, offline, sleep] = this.tabItems;
        // const { data } = nowVal;
        // all.data = data;
        // online.data = data.filter(({ type }) => type === 0);
        // offline.data = data.filter(({ type }) => type === 1);
        // sleep.data = data.filter(({ type }) => type === 2);

        // //如果两个数组成员不一致则刷新页数
        // const nowGids = [...nowVal.gids];
        // const curGids = [...curVal.gids];
        // if (JSON.stringify(nowGids) !== JSON.stringify(curGids)) {
        //   all.currentPage = 1;
        //   online.currentPage = 1;
        //   offline.currentPage = 1;
        //   sleep.currentPage = 1;
        // }
      },
      deep: true
    },

    //处理搜索值变化
    searchValue: {
      async handler(val) {
        this.currentPage = 1;
        this.$emit("update:cyclePagger", this.currentPage);
        let vehicleId = val ? val.vehicleId : undefined;
        vehicleId !== undefined && (await this.getMonitor(val));
        const organizationId = val
          ? val.organizationId || val.groupId
          : undefined;
        this.openKeys = [organizationId];
        if (organizationId) {
          this.gids.push(organizationId);
        }
        const { scrollToTreeHighLight, scrollToVehHighLight } = this;
        organizationId !== undefined && scrollToTreeHighLight(organizationId);
        vehicleId !== undefined && scrollToVehHighLight(vehicleId);
      },
      deep: true
    }
  },
  methods: {
    async specification(value){
        try {
            this.specificationData.vehicleId = this.selectOption.vehicleId;
            this.specificationData.commandMsg = value;
            const params = {
            ...this.specificationData
            };
            const { msg } = await this.$API.commandDown(params);
            this.$msg({
                showClose: true,
                message: msg,
                type: "success"
            });
        } catch {
            this.$msg({
                showClose: true,
                message: '请求错误' ,
                type: "error"
            });
        }
    },
    ...mapMutations(['COMMIT_NUMBER']),
    //转标准树状图
    treeFormat(data) {
      for (let item of data) {
        item.children = item.organizationsList;
        if (item.organizationsList && item.organizationsList.length > 0) {
          this.treeFormat(item.organizationsList);
        }
      }
      return data;
    },
    //获取查询数据所在页数
    async getMonitor(val) {
      const { vehicleId } = val;
      const organizationId = val.organizationId || val.groupId;
      try {
        const pagger = (
          await this.$API.getMonitor({
            organizationId: this.gids.join(",") || organizationId,
            vehicleId,
            total: this.pageSize
          })
        )["data"];
        this.selectPagger = pagger.pagger;
        this.currentPage = this.selectPagger;

        this.$emit("update:cyclePagger", this.currentPage);
        await this.updateVehGroup(this.gids);
        //刷新当前页数据
      } catch (error) {
        console.log(error);
      }
    },
    //设备详情日期处理
    dateFormat(str) {
      if (!str) return;
      const year = str.split(" ")[0];
      const date = str.split(" ")[1].split(".")[0];
      if (!date) {
        const date2 = str.split(" ")[1];
        return [year, date2].join(" ");
      }
      return [year, date].join(" ");
    },
    setOption(data) {
      this.selectOption = data;
      this.isCKBMS = this.selectOption.terminalType == 'LD-01A'?true:false;
      this.isSUNWODA = this.selectOption.terminalType == "GPRS-SUNWODA"?true:false;
    },
    async optionsFn(data,title) {
      if (data === 1) {
        this.DeviceDetailVisible = true;
        await this.getDetail(this.selectOption);
      } else if (data === 2) {
        this.CommandDownVisible = true;
        this.isData = '';
      } else if (data === 3) {
        this.ChargeTaggleVisible = true;
      } else if(data == 'CKBMS:0' || data == 'CKBMS:1'){
        this.CommandDownVisible = true;
        this.isData = data;
      } else if(data === 11){
        this.remoteUpgradeVisible = true;
        this.remoteUpgradeData = title;
      }  else if(data === 12){
        this.registerVisible = true;
        this.remoteUpgradeData = title;
      }else if(data >= 4){
        this.InstVisible = true;
        this.instType = data;
        this.instTitle = title;
      }
    },
    //获取设备详情
    async getDetail(item) {
      try {
        const { vehicleId } = item;
        const data = (
          await this.$API.getVehicleDetali({
            vehicleId
          })
        )["data"];
        let address = '';
        if(data.provinceCode){
            this.addressArr.map(item => {
                if(data.provinceCode == item.code){
                    address += item.name + '-';
                    item.list.map(key => {
                        if(key.code == data.cityCode){
                            address += key.name + '-';
                            key.list.map(val => {
                                if(val.code == data.countyCode){
                                    address += val.name;
                                }
                            })
                        }
                    })
                }
            })
        }
        this.vehicleDetail = [
          {
            title: "激活时间",
            value: this.dateFormat(data.activationTme) || "暂无数据"
          },
          { title: "电池编号", value: data.bmsNo || "暂无数据" },
          { title: "电池类型", value: data.bmsType || "暂无数据" },
          {
            title: "创建时间",
            value: this.dateFormat(data.createTime) || "暂无数据"
          },
          {
            title: "安装时间",
            value: this.dateFormat(data.doDate) || "暂无数据"
          },
          // { title: "组织ID", value: data.groupId || "暂无数据" },
          { title: "组织名称", value: data.groupName || "暂无数据" },
          // { title: "IP地址", value: data.ipAddress || "暂无数据" },
          // { title: "续费多少个月", value: data.renewNum || "暂无数据" },
          { title: "服务密码", value: data.serviceCode || "暂无数据" },
          { title: "SIM号", value: data.sim || "暂无数据" },
          { title: "设备号", value: data.terminalNo || "暂无数据" },
          { title: "设备类型", value: data.terminalType || "暂无数据" },
          // { title: "更新时间", value: data.updateTime || "暂无数据" },
          // { title: "终端ID", value: data.vehicleId || "暂无数据" },
          { title: "备注", value: data.installRemark || "暂无数据" },
        ];
        if(address){
            this.vehicleDetail.push({ title: "地址", value: address || "暂无数据" });
        }
      } catch (error) {
        console.log(error);
      }
    },
    currentChange(val) {
      this.$emit("update:cyclePagger", val);
      this.updateVehGroup(this.gids);
    },
    selectType(item) {
      this.$emit("update:type", item.type);
      this.currentPage = 1;
      this.$emit("update:cyclePagger", this.currentPage);
      setTimeout(() => {
        this.updateVehGroup(this.gids);
      }, 0);
    },
    computedVehState({ type, date }) {
      return (
        ["在线", "离线", "休眠", "从未上线", "过期"][type] + (date ? date : "")
      );
    },
    //清除所有数据
    clearAllData() {
      this.searchValue = null;
      this.gids = []; //清空选择组织id
      this.total = 0; //清空分页
      this.dataList = []; //清空设备信息
      this.$refs.tree.setCurrentKey(null); //取消当前节点高亮
      this.$refs.tree.setCheckedKeys([]); //取消已选择节点
      // this.isAllSelect = false; //取消车辆全选
      this.selectIds = new Set();
      this.selectVeh = null;
      this.$emit("update:vehGroup", {
        data: Object.freeze([]),
        gids: new Set()
      });
      ///更新已选设备索引
      this.$emit("update:vehIndices", {
        value: new Map(),
        timestamp: Date.now()
      });
      //更新当前设备数据
      this.$emit("update:vehInfo", null);

      ///更新已选设备索引
      this.$emit("update:monitorInfo", {
        value: new Map(),
        timestamp: Date.now()
      });
      //更新当前设备数据
      this.$emit("update:selectMonitorInfo", null);

      ///更新已选设备索引
      this.$emit("update:electricData", {
        value: new Map(),
        timestamp: Date.now()
      });
      //更新当前设备数据
      this.$emit("update:selectElectricData", null);
    },

    //获取当前点击设备地图信息
    async getPositionData(veh) {
      if (!veh) return;
      try {
        const positionData = (
          await this.$API.getPosInfo({
            vehicleId: veh.vehicleId
          })
        )["data"];
        //给设备电池数据添加organizationId和vehicleId字段，用于后面的取消操作。
        positionData.vehicleId = veh.vehicleId;
        positionData.organizationId = veh.organizationId;
        return positionData;
      } catch (error) {
        console.log(error);
      }
    },

    //获取当前点击设备电池信息
    async getMonitorInfo(veh) {
      try {
        if(!veh)return;
        const getMonitorInfo = (
          await this.$API.getDeviceRealBMSData({
            terminalNo: veh.terminalNo
          })
        )["data"];
        this.num_data++;
        //给设备电池数据添加organizationId和vehicleId字段，用于后面的取消操作。
        getMonitorInfo.organizationId = veh.organizationId;
        getMonitorInfo.vehicleId = veh.vehicleId;
        this.COMMIT_NUMBER(getMonitorInfo.COMPANY)
        return getMonitorInfo;
      } catch (error) {
        console.log(error);
      }
    },
    //当前点击设备电流曲线信息
    async getElectricData(veh) {
      try {
        const getElectricData = (
          await this.$API.getElectricCurve({
            vehicleId: veh.vehicleId
          })
        )["data"];
        return getElectricData;
      } catch (error) {
        console.log(error);
      }
    },

    //处理veh item点击
    //flag 为true时表示选中
    //点击单条设备，选中/取消该设备并获当当前已选所有设备详细信息
    async handleOnVehItemClick(veh, flag) {
      if ((veh.type && veh.type === 3) || (veh.type && veh.type === 4)) {
        this.$msg({
          showClose: true,
          message: "未激活",
          type: "warning"
        });
        return;
      }

      let vehIndices,
        vehInfo,
        monitorInfo,
        selectMonitorInfo,
        electricData,
        selectElectricData;
      //选中设备
      if (flag) {
        this.selectVeh = veh;
        veh.vehicleId && this.selectIds.add(veh.vehicleId);
        if (this.vehInfo && veh.vehicleId === this.vehInfo.vehicleId) {
          this.$emit("onZoomMarker");
          return;
        }
        //当前点击设备地图信息
        const positionData = await this.getPositionData(veh);

        //当前点击设备电池监控信息
        const getMonitorInfo = await this.getMonitorInfo(veh);
        let self = this;
        // setInterval(()=>{
        //     selectMonitorInfo = this.getMonitorInfo(veh);
        //     console.log('进来')
        // },1000 * 16)
        //当前点击设备电流曲线信息
        const getElectricData = await this.getElectricData(veh);
        vehInfo = positionData; //获取当前选中设备地图信息
        selectMonitorInfo = getMonitorInfo; //获取当前选中设备电池信息
        selectElectricData = getElectricData; //获取当前选中设备电流曲线信息
        //存储选中的所有设备的信息
        vehIndices = new Map([
          [veh.vehicleId, positionData],
          ...this.vehIndices.value
        ]);
        monitorInfo = new Map([
          [veh.vehicleId, getMonitorInfo], //将最新选中的设备信息存储在第一位
          ...this.monitorInfo.value //选中当前设备前的所有选中设备信息
        ]);
        electricData = new Map([
          [veh.vehicleId, getElectricData],
          ...this.electricData.value
        ]);
      } else {
        this.selectIds.delete(veh.vehicleId);
        this.selectIds = new Set([...this.selectIds]);
        //取消选中设备，先获取已选中所有设备信息
        vehIndices = new Map(this.vehIndices.value);
        const values = [...vehIndices.values()];
        //获取当前选中设备在已选所有设备数组中的索引值
        const i = values.findIndex(
          ({ vehicleId }) => vehicleId === veh.vehicleId
        );
        //判断取消的设备是否为当前选中设备，是则选中上一条，否则保持选中当前设备
        if (veh.vehicleId === values[0].vehicleId) {
          vehInfo = values[i + 1] || values[i - 1];
        } else {
          vehInfo = values[0];
        }
        this.selectVeh = vehInfo;
        vehIndices.delete(veh.vehicleId);

        monitorInfo = new Map(this.monitorInfo.value);
        const values2 = [...monitorInfo.values()];
        if (veh.vehicleId === values[0].vehicleId) {
          selectMonitorInfo = values2[i + 1] || values2[i - 1];
        } else {
          selectMonitorInfo = values2[0];
        }
        monitorInfo.delete(veh.vehicleId);

        electricData = new Map(this.electricData.value);
        const values3 = [...electricData.values()];

        //取消设备若是最新选中设备则默认选择下一设备或上一设备，若不是取消最新选中设备则继续显示最新设备信息
        if (veh.vehicleId === values[0].vehicleId) {
          selectElectricData = values3[i + 1] || [i - 1];
        } else {
          selectElectricData = values3[0];
        }
        //取消选中后从选中列表中删除该设备
        electricData.delete(veh.vehicleId);
      }
      //更新已选设备信息
      this.$emit("update:monitorInfo", {
        value: monitorInfo,
        timestamp: Date.now()
      });
      this.$emit("update:electricData", {
        value: electricData,
        timestamp: Date.now()
      });
      this.$emit("update:vehIndices", {
        value: vehIndices,
        timestamp: Date.now()
      });
      //显示选择的下一设备或上一设备信息
      this.$emit("update:vehInfo", Object.freeze(vehInfo));
      this.$emit("update:selectMonitorInfo", Object.freeze(selectMonitorInfo));
      this.$emit(
        "update:selectElectricData",
        Object.freeze(selectElectricData)
      );
    },
    //滚动到树状图当前高亮节点
    async scrollToTreeHighLight(organizationId) {
      //logic 选中
      let gids = new Set(this.vehGroup.gids);
      gids.add(organizationId);
      // this.isAllSelect = false;
      await this.updateVehGroup([...gids]);
      //css 选中
      this.$refs.tree.setCurrentKey(organizationId);
      await this.$nextTick();
      await this.$sleep(100);
      const activeDom = this.$refs.tree.$el.getElementsByClassName(
        "is-current"
      )[0];
      activeDom && activeDom.scrollIntoView();
    },
    //滚动到当前高亮节点
    async scrollToVehHighLight(vehicleId) {
      await this.$nextTick();
      this.activeTab = "all";
      //获取查询类型为all的全部数据
      // const allData = this.tabItems[0];
      // const i = allData.data.findIndex(item => item.vehicleId === vehicleId);
      // allData.currentPage = Math.ceil(i / this.pageSize) || 1;
      await this.$sleep();
      //判断输入框查询数据的vehicleId是否在当前页中存在
      let mark = this.dataList.find(function(elem) {
        return elem.vehicleId === vehicleId;
      }, this);
      //若查询数据在当前页，则选中该数据
      if (mark) {
        //选中搜查询的那条,注意选中后才滚动handleOnVehItemClick
        await this.handleOnVehItemClick(mark, true);
        const activeDom = this.$refs.VehSelect.getElementsByClassName(
          "VehItem_active"
        )[0];
        activeDom && activeDom.scrollIntoView();
      } else {
        this.$msg({
          showClose: true,
          message: "未找到该数据",
          type: "warning"
        });
        // //若查询数据不再当前页，则查询下一页
        // this.currentPage = this.selectPagger;
        // //刷新当前页数据
        // await this.updateVehGroup(this.gids);
        // //递归
        // await this.scrollToVehHighLight(vehicleId);
      }
    },
    //轮询
    // dataRefresh() {
    //   clearInterval(this.refresh.timer);
    //   this.refresh.num = 30;
    //   this.refresh.timer = setInterval(async () => {
    //     this.refresh.num === 0 ? (this.refresh.num = 30) : this.refresh.num--;
    //     if (this.refresh.num === 0) {
    //       if (this.$route.path !== "/monitorCenter") return;
    //       //每30秒获取设备数据
    //       if (this.selectVeh && this.selectVeh.vehicleId) {
    //         await this.handleOnVehItemClick(this.selectVeh, true);
    //       }
    //       await this.updateVehGroup(this.gids);
    //     }
    //   }, 3000 * 10);
    // },
    //获取新的车组数据, 并与老的组合
    async updateVehGroup(gids) {
      if (gids.length === 0) {
        this.$emit("update:vehGroup", {
          data: Object.freeze([]),
          gids: new Set()
        });
        return;
      }
      try {
        this.loading = true;
        // const curGidsSet = this.vehGroup.gids;
        // const curGids = [...curGidsSet];
        // //获取旧车辆
        // const gidsSet = new Set(gids);
        // const extra = curGids.filter(gid => !gidsSet.has(gid)); //有用的旧车组
        // const extraSet = new Set(extra);
        // const curData = this.vehGroup.data.filter(
        //   item => !extraSet.has(item.organizationId)
        // ); //有用的旧车组车辆

        //获取新车辆
        // const ids = gids.filter(gid => !curGidsSet.has(gid));
        // const nowData = ids.length
        //获取当前组织下所有设备基本信息（不包含设备详情）
        const alldata = gids.length
          ? (
              await this.$API.getVehicleState({
                organizationIds: gids.join(","),
                pagger: this.currentPage,
                total: this.pageSize,
                type: this.type
              })
            )["data"]
          : [];
        //设备基本信息
        const nowData = alldata.MonitoringCenterVos;
        //合并新旧设备
        const data = [...(nowData || [])];
        this.tabItems[0].total = alldata.tatol; //总数
        this.tabItems[1].total = alldata.online; //在线
        this.tabItems[2].total = alldata.line; //离线
        // this.tabItems[3].total = alldata.dormancy; //休眠
        this.dataList = nowData;
        if (this.type === 3) {
          this.total = alldata.tatol;
        } else {
          this.total = this.tabItems[this.type + 1].total;
        }
        //组织可多选，更新已选组织下的所有设备信息
        this.$emit("updateGroup", gids, data);
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "warning"
        });
      }
    },
    //处理树状图点击选择框
    // async handleCheck(data) {
    //   this.currentPage = 1;
    //   const waitChecks = getWaitChecks(data); //待选择节点
    //   const waitChecksSet = new Set(waitChecks);
    //   const checkedKeys = this.$refs.tree.getCheckedKeys(); //已选节点
    //   const checkedKeysSet = new Set(checkedKeys);
    //   const allChecks = [...new Set([...waitChecks, ...checkedKeys])];
    //   if (allChecks.length > 1000 && checkedKeysSet.has(data.organizationId)) {
    //     const i = checkedKeys.indexOf(data.organizationId);
    //     checkedKeys.splice(i, 1);
    //     this.$refs.tree.setCheckedKeys(checkedKeys); //取消当前选择车组
    //     this.$toast.fail({
    //       duration: 1000,
    //       message: "不可选择大于1000个车组"
    //     });
    //     return;
    //   }

    //   //如已被选择则取消选择，反之选择
    //   let nowCheckedKeys = [];
    //   if (checkedKeysSet.has(data.organizationId)) {
    //     nowCheckedKeys = allChecks;
    //   } else {
    //     nowCheckedKeys = checkedKeys.filter(gid => !waitChecksSet.has(gid));
    //   }
    //   this.$refs.tree.setCheckedKeys(nowCheckedKeys);

    //   //加载车组
    //   if (checkedKeysSet.has(data.organizationId)) {
    //     //选中
    //     const ids = [...new Set([...this.vehGroup.gids, ...nowCheckedKeys])];
    //     await this.updateVehGroup(ids);
    //     // await this.allSelect(true, waitChecksSet); //全选
    //   } else {
    //     let ids = [];
    //     //取消选择
    //     //如果有通过下划线选取的车组时
    //     if (this.vehGroup) {
    //       const gids = [...this.vehGroup.gids];
    //       ids = gids.filter(gid => !waitChecksSet.has(gid)); //返回所有未在待选车组的下划线车组
    //       await this.updateVehGroup(ids);
    //     }
    //     // await this.allSelect(false, waitChecksSet); //全选
    //   }

    //   //获取待选择节点
    //   function getWaitChecks(data) {
    //     let waitChecks = [data.organizationId]; //待选择节点
    //     runChildren(data);
    //     return waitChecks;

    //     function runChildren(data) {
    //       if (data.children) {
    //         data.children.map(item => {
    //           waitChecks.push(item.organizationId);
    //           runChildren(item);
    //         });
    //       }
    //     }
    //   }
    //   if (nowCheckedKeys.length === 0 && this.vehGroup.gids.size === 0) {
    //     this.dataList = [];
    //   }
    // },
    //flag是否全选
    //如果waitChecksSet存在则执行点击树状图选择框时的逻辑
    // async allSelect(flag, waitChecksSet) {
    //   let vehIndices = null;
    //   let isAllErrMsg = true; //判断是否全部有errMsg
    //   const { data } = this.vehGroup;
    //   if (flag) {
    //     let new_indices = [];
    //     data.map(item => {
    //       if (item.type === 3) return; //type 为 3 时则代表从未在线
    //       isAllErrMsg = false;
    //       if (waitChecksSet) {
    //         //选择具有树状图选择框下车组id的车辆
    //         waitChecksSet.has(item.organizationId) &&
    //           new_indices.push([item.vehicleId, item]);
    //       } else {
    //         new_indices.push([item.vehicleId, item]);
    //       }
    //     });
    //     vehIndices = waitChecksSet
    //       ? new Map([...new_indices, ...this.vehIndices.value])
    //       : new Map(new_indices);
    //   } else {
    //     isAllErrMsg = false;

    //     if (waitChecksSet) {
    //       //取消选择具有树状图选择框下车组id的车辆
    //       let indices = new Map();
    //       [...this.vehIndices.value.values()].map(item => {
    //         if (waitChecksSet.has(item.organizationId)) return;
    //         indices.set(item.vehicleId, item);
    //       });
    //       vehIndices = indices;
    //     } else {
    //       vehIndices = new Map();
    //     }
    //   }
    //   if (isAllErrMsg) {
    //     this.$msg({
    //       showClose: true,
    //       message: "无可选车辆",
    //       type: "warning"
    //     });
    //     return;
    //   }

    //   this.isAllSelect = flag;
    //   //更新已选车辆索引
    //   this.$emit("update:vehIndices", {
    //     value: vehIndices,
    //     timestamp: Date.now()
    //   });
    //   //全选时默认地图车辆为第一辆
    //   this.$emit("update:vehInfo", Object.freeze([...vehIndices.values()][0]));
    // },
    //处理树节点点击
    async hanldeNodeClick({ organizationId }, node) {
      this.currentPage = 1;
      this.$emit("update:cyclePagger", this.currentPage);
      //加载当前车组内车辆信息
      let gids = new Set(this.vehGroup.gids); //复制gids
      if (gids.has(organizationId)) {
        this.searchValue = null;
        this.selectIds = new Set();
        gids.delete(organizationId);
        //取消选中组织
        let vehIndices = new Map();
        let monitorInfo = new Map();
        [...this.vehIndices.value.values()].map(item => {
          if (item.organizationId === organizationId) return;
          vehIndices.set(item.vehicleId, item);
          this.selectIds.add(item.vehicleId);
        });
        [...this.monitorInfo.value.values()].map(item => {
          if (item.organizationId === organizationId) return;
          monitorInfo.set(item.vehicleId, item);
        });
        if ([...gids].length === 0) {
          this.dataList = [];
          this.total = 0;
        }
        const vehs = [...vehIndices.values()];
        const vehs2 = [...monitorInfo.values()];
        if (vehs.length === 0) {
          this.selectVeh = null;
          this.$emit("update:vehInfo", null);
          this.$emit("update:vehIndices", {
            value: new Map(),
            timestamp: Date.now()
          });
        } else {
          //如果地图上的车辆属于取消的车组则选取vehIndices内第一辆车辆
          this.vehInfo.organizationId === organizationId &&
            this.$emit("update:vehInfo", Object.freeze(vehs[0]));
          this.selectVeh = Object.freeze(vehs[0]);
          this.$emit("update:vehIndices", {
            value: vehIndices,
            timestamp: Date.now()
          });
        }
        if (vehs2.length === 0) {
          this.$emit("update:selectMonitorInfo", null);
          this.$emit("update:monitorInfo", {
            value: new Map(),
            timestamp: Date.now()
          });
        } else {
          //如果地图上的车辆属于取消的车组则选取vehIndices内第一辆车辆
          this.selectMonitorInfo.organizationId === organizationId &&
            this.$emit("update:selectMonitorInfo", Object.freeze(vehs[0]));
          this.$emit("update:monitorInfo", {
            value: monitorInfo,
            timestamp: Date.now()
          });
        }
      } else {
        gids.add(organizationId);
      }
      //取消选中当前车组(多选框)
      node.checked && this.$refs.tree.setChecked(organizationId, false);
      // this.isAllSelect = false;
      this.gids = [...gids];
      await this.updateVehGroup([...gids]);
      this.$nextTick();
    }
  }
};
</script>

<style lang="scss" scoped>
.tree {
  height: 36%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(#999, 0.3);
  border-radius: 5px;

  &__icon {
    margin: 0 5px 0 10px;
    font-size: 14px;
    color: gray;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 33px;
    padding: 0 10px;
    border-bottom: 1px solid rgba(#999, 0.3);
    overflow: hidden;
  }

  &__title {
    font-size: 14px;
    font-weight: bold;
  }

  &__content {
    @include scrollBar;
    // flex: 1;
    height: 100%;
    overflow-y: auto;
    background: #fff;
  }

  &__total {
    color: currentColor;
    margin-left: 5px;
  }

  &__node {
    &_on {
      color: $primary;
    }
  }
}
.block_div{
  display: block !important;
}
.optionBtn {
  padding: 5px 0;
  border-top: 1px solid rgb(224, 224, 224);
  .options {
    color: #b4b4b4;
    display: inline;
    cursor: pointer;
    &:hover {
      color: #2a83de;
    }
  }
  &:nth-child(1) {
    border-top: none;
  }
}
.VehSelect {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &__nav {
    display: flex;
    height: 60px;
    // overflow: hidden;
    margin: 5px;
  }

  &__tab-item {
    background: #ececec;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #999;
    padding: 8px 5px;
    cursor: pointer;
    user-select: none;

    &:hover {
      background: $primary;
      color: #fff;
    }

    & + & {
      margin-left: 5px;
    }

    &_on {
      background: $primary;
      color: #fff;
    }
  }

  &__cancel {
    display: flex;
    justify-content: flex-end;
    padding: 0 10px;
    border: 1px solid rgba(#999, 0.3);
  }

  &__cancel-btn {
    color: $primary;
    user-select: none;
    cursor: pointer;
    font-size: 12px;
  }
  &__box {
    @include scrollBar;
    height: 100%;
    overflow-y: auto;
    background-color: #fff;
  }
  &__box2 {
    @include scrollBar;
    height: 100%;
    overflow-y: hidden;
    background-color: #fff;
  }
  &__loading {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__tab-pane {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  &__tab-pane-content {
    @include scrollBar;
    flex: 1;
    overflow-y: auto;
    background: #fff;
    position: relative;
  }
}

.VehItem {
  display: flex;
  font-size: 12px;
  padding: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  & + & {
    margin-top: 2px;
  }

  &_on {
    background: rgba($primary, 0.1);
  }

  &_disabled {
    background: rgba(150, 151, 153, 0.2);
  }

  &_valid:not(.VehItem_on) {
    &:hover {
      background: #f5f7fa;
    }
  }

  &__veh-icon {
    color: #bdbdbd;
    margin-right: 5px;
  }

  &_online {
    .VehItem__veh-icon {
      color: $primary;
    }
  }

  &_stop {
    .VehItem__veh-icon {
      color: #2a83de;
    }
  }

  &__plate {
    @include ellipsis;
    width: 140px;
    color: #666;
  }

  &__status {
    @include ellipsis;
    padding: 1px 0;
    flex: 1;
    color: #666;
    padding-right: 15px;
  }

  &__setting-icon {
    color: $primary;
    margin-left: 5px;
  }
  &_active {
    background-color: #b0fbe2;
  }
}
</style>
